export enum LinkField {
    ContractPdfUrl = 'ContractPdfUrl',
    ContractESignUrl = 'ContractESignUrl'
}
